import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import LayoutPanel from '@/components/layouts/Panel.vue'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false
Vue.component('layout-panel', LayoutPanel)
Vue.use(VueAnalytics, { id: process.env.VUE_APP_ANALYTICS_KEY })

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
